import { isRiskFree as protoIsRiskFree } from '@wkda/funnel-modules';
export function isValid(carLeadData) {
  const priceExpiresInDays = carLeadData?.data?.priceExpiresInDays;
  const isValid = priceExpiresInDays !== 0;
  return isValid;
}
export function getPriceStatus(carLeadData) {
  const riskFree = protoIsRiskFree(carLeadData?.data);
  const valid = isValid(carLeadData);
  const statusMap = {
    expired: 'expired',
    reeva: 'reeva',
    valid: 'valid'
  };
  if (valid) return statusMap.valid;
  if (!valid && riskFree) return statusMap.expired;
  if (!valid && !riskFree) return statusMap.reeva;
  return '';
}